import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';

import Home from '@/pages/public/Home';
import Gallery from '@/pages/public/Gallery';
import About from '@/pages/public/About';
import Contact from '@/pages/public/Contact';
import Login from '@/pages/auth/Login';
import Register from '@/pages/auth/Register';

import ErpLayout from '@/components/erp/ErpLayout';
import Dashboard from '@/pages/erp/Dashboard';
import Clients from '@/pages/erp/Clients';
import Suppliers from '@/pages/erp/Suppliers';
import Trips from '@/pages/erp/Trips';
import Calculator from '@/pages/erp/Calculator';
import Sales from '@/pages/erp/Sales';
import Finance from '@/pages/erp/Finance';
import Users from '@/pages/erp/Users';
import Leads from '@/pages/erp/Leads';
import Settings from '@/pages/erp/Settings';

import PortalLayout from '@/components/portal/PortalLayout';
import MyTrips from '@/pages/portal/MyTrips';
import MyProfile from '@/pages/portal/MyProfile';

const STAFF = ['admin', 'supervisor', 'vendedor'];
const MANAGER = ['admin', 'supervisor'];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/galeria" element={<Gallery />} />
      <Route path="/quem-somos" element={<About />} />
      <Route path="/contato" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/erp" element={<ProtectedRoute roles={STAFF}><ErpLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ProtectedRoute roles={STAFF}><Dashboard /></ProtectedRoute>} />
        <Route path="viagens" element={<Trips />} />
        <Route path="calculadora" element={<ProtectedRoute roles={MANAGER}><Calculator /></ProtectedRoute>} />
        <Route path="vendas" element={<Sales />} />
        <Route path="leads" element={<Leads />} />
        <Route path="clientes" element={<Clients />} />
        <Route path="fornecedores" element={<Suppliers />} />
        <Route path="usuarios" element={<ProtectedRoute roles={MANAGER}><Users /></ProtectedRoute>} />
        <Route path="financeiro" element={<ProtectedRoute roles={MANAGER}><Finance /></ProtectedRoute>} />
        <Route path="configuracoes" element={<ProtectedRoute roles={MANAGER}><Settings /></ProtectedRoute>} />
      </Route>

      <Route path="/portal" element={<ProtectedRoute roles={['cliente']}><PortalLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="viagens" replace />} />
        <Route path="viagens" element={<MyTrips />} />
        <Route path="perfil" element={<MyProfile />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
